import React, { Component } from 'react';
import Slider from "react-slick";

// Images
import Image1 from "../../../images/slider/slide5.jpg"
import Image2 from "../../../images/homepage-banner-2.webp"
import { Link } from 'react-router-dom';
import Homevideo from '../../../images/video_homepage.mp4'

class Slider2 extends Component{
	
	render(){
		
		const settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			slidesToScroll: 1,
		};
		
		return(
			<>
				
				<Slider {...settings} className="tt-slider slider-sp0 slider-two">
					<div className="slider-item">
						<div className="slider-thumb ovbl-middle">
							<video
							autoPlay
							muted
							loop
							playsInline
							className="hero-video"
						>
							<source src={Homevideo} type="video/mp4" />
						</video>
						</div>
						<div className="slider-content text-center text-white">
							<div className="container">
								<div className="content-inner">
									<h6 className="sub-title">Global Oilfield & Power Services</h6>
									<h2 className="title">Solutions That Elevate<br/>Energy Performance</h2>
									<Link className="btn primary" to="contact">Contact Us</Link>
								</div>
							</div>
						</div>
					</div>			
					<div className="slider-item">
						<div className="slider-thumb ovbl-middle">
							<img src={Image2} alt=""/>
						</div>
						<div className="slider-content text-center text-white">
							<div className="container">
								<div className="content-inner">
									<h6 className="sub-title">Global Oilfield & Power Services</h6>
									<h2 className="title">Expertise that Powers<br/>Africa’s Energy Sector</h2>
									<Link className="btn primary" to="contact">Contact Us</Link>
								</div>
							</div>
						</div>
					</div>					
				</Slider>
				
			</>
		);
	}
}

export default Slider2;